const USERS = [
    { id: '00000000-0000-0000-0000-000000000001', name: 'LCG' },
    { id: '00000000-0000-0000-0000-000000000003', name: 'SGW' },
  ];
  
  export default function UserPicker({ value, onChange, style }) {
    return (
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          padding: '8px 12px',
          borderRadius: 6,
          border: '1px solid #ddd',
          fontSize: 14,
          ...style,
        }}
      >
        {USERS.map((user) => (
          <option key={user.id} value={user.id}>
            {user.name}
          </option>
        ))}
      </select>
    );
  }